import { render, staticRenderFns } from "./kPagination.vue?vue&type=template&id=3f5efbaf"
import script from "./kPagination.vue?vue&type=script&lang=js"
export * from "./kPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports